import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, change } from 'redux-form';
import {FormattedHTMLMessage} from 'react-intl';
import withAuthControl from '../auth/Auth.js';
import TopScrolleable from './TopScrolleable.js'
import Section from './Section.js'
import CustomSpinner from './CustomSpinner';
import RenderField from './RenderField';
import CustomAlert from './CustomAlert.js';
import StatesList from '../containers/StatesContainer.js';
import Whatsapp from './WhatsappButton.js';
import CustomAutosuggestMobileFriendly from './CustomAutosuggestMobileFriendly';
import AttributeOptions from './AttributeOptions.js';
import validate from './Validations/submitValidationsPryAddressForm';
import SaveStepButton from './SaveStepButton';
import axios from 'axios';


class PryAddressForm extends Component {

    constructor(props) {
        super(props);
        this.state = { cities: null};
        this.state = { viewDetailLocation: false };
        this.state = { address_confirm: null };

        this.handleCitySelect = this.handleCitySelect.bind(this);
    }
    componentDidMount() {
        /*    const ROOT_URL = process.env.API_URL;
            const config = {
                headers:
                    {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
                    }
            };
            axios.get(`${ROOT_URL}/steps/param?param=address_confirm`, config).then((response)=> {
                this.setState({
                    address_confirm: response.data.address_confirm,
                  });
            });
        */
    }
    handleCitySelect(city) {
        const { dispatch, form } = this.props;

        dispatch(change(form, 'pry_zip_code', city.zip_code));
    }

    render() {
        const { handleSubmit, submitting, error, state_id } = this.props;
        const viewMoreLocation = (event) => {
            event.preventDefault();
            this.state.viewDetailLocation ? this.setState({viewDetailLocation: false}) : this.setState({viewDetailLocation: true});
        }
        const provinces_options = [{id:12 , name:'Mendoza'}]

        return (
            <Section className="intro_form">
                <div className="row">
                    <div className="pd-content-left col-md-5 col-lg-5 text-center">
                        <img alt="Logo" className="center-block intro_logo" src={require(`../assets/${process.env.PAGE}/img/logo-h-blanco.png`)}/>
                        <FormattedHTMLMessage id="app.step_pry_address" description="Address info"/>
                        <Whatsapp phone={this.context.intl.formatMessage({
                                      id:"app.step_sms_whatsapp_number", defaultMessage: "542612554220"})}
                                  text={this.context.intl.formatMessage({
                                      id:"app.step_sms_whatsapp_text", defaultMessage: "Tengo+una+consulta"})}
                                  value={this.context.intl.formatMessage({
                                      id:"app.step_sms_whatsapp_label", defaultMessage: "261-2554-220"})}
                                  gaEvent="true" gaCategory="CallToAction" gaAction="WhatsApp Tapping"/>
                        <FormattedHTMLMessage id="app.whatsapp_timetable" description="Wp timetable"/>
                        <SaveStepButton/>
                    </div>
                    <div className="pd-content-right col-sm-12 col-md-7 col-lg-7">
                        <form onSubmit={handleSubmit(this.props.savePryAddress)} className="pvc-form" autoComplete="asd">
                            {this.props.isLoading && <CustomSpinner message='Estamos analizando tu solicitud. Por favor esperá...' /> }
                            {error && <CustomAlert bsStyle="danger" message={error}/>}
                            {/*this.state.address_confirm == 0 && (<div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                    <div className="form-group">
                                        <AttributeOptions name="state_id" defaultValue="Provincia" label="Provincia" attributeName='state_id' attributeOptions={provinces_options}/>
                                    </div>
                                </div>
                                  </div>)*/}
                            {/*this.state.address_confirm == 1 && (<div className="row">
                                    <StatesList />
                                </div>)*/}
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                    <div className="form-group">
                                        <AttributeOptions name="state_id" defaultValue="Provincia" label="Provincia" attributeName='state_id' attributeOptions={provinces_options} />
                                    </div>
                                </div>
                            </div>                               
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                    <div className="form-group">
                                        <Field className="form-control" name="pry_form_locality" attributeName='form_locality' autoComplete="asd" component={CustomAutosuggestMobileFriendly} selectedState={state_id} onChange={this.handleCitySelect} type="text" label="Localidad" />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                    <div className="form-group">
                                        <Field className="form-control" name="pry_zip_code" autoComplete="off" component={RenderField} type="number" label="Código Postal" />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                    <div className="form-group">
                                        <Field className="form-control" name="pry_address_street" autoComplete="off" component={RenderField} type="text" label="Calle y número" />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                    <div className="form-group">
                                        <Field className="form-control" name="cadastral_nomenclature" autoComplete="off" component={RenderField} type="nomenclature" label="Nomenclatura Catastral" />
                                    </div>
                                </div>
                            </div>
                            <div style={{textAlign: 'center', cursor: 'pointer'}}>
                                <i onClick={(event) => viewMoreLocation(event)}> 
                                    <b>Información adicional {this.state.viewDetailLocation ? <img className="save-step-icon" src={require(`../assets/${process.env.PAGE}/img/arrow-up.png`)}/> : <img className="save-step-icon" src={require(`../assets/${process.env.PAGE}/img/arrow-down.png`)}/> }</b>
                                </i>
                            </div>
                            {this.state.viewDetailLocation && (
                                <div>
                                    <div style={{display: 'grid', gridTemplateColumns: 'auto auto auto'}}>
                                        <div className="row">
                                            <div className="col-sm-12 col-md-12 col-lg-12">
                                                <div className="form-group">
                                                    <Field className="form-control" name="pry_building" autoComplete="off" component={RenderField} type="text" label="Edificio" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm-12 col-md-12 col-lg-12">
                                                <div className="form-group">
                                                    <Field className="form-control" name="pry_flat" autoComplete="off" component={RenderField} type="text" label="Piso" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm-12 col-md-12 col-lg-12">
                                                <div className="form-group">
                                                    <Field className="form-control" name="pry_department" autoComplete="off" component={RenderField} type="text" label="Dpto" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div style={{display: 'grid', gridTemplateColumns: 'auto auto auto'}}>
                                        <div className="row">
                                            <div className="col-sm-12 col-md-12 col-lg-12">
                                                <div className="form-group">
                                                    <Field className="form-control" name="pry_quarter" autoComplete="off" component={RenderField} type="text" label="Barrio" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm-12 col-md-12 col-lg-12">
                                                <div className="form-group">
                                                    <Field className="form-control" name="pry_apple" autoComplete="off" component={RenderField} type="text" label="Manzana" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm-12 col-md-12 col-lg-12">
                                                <div className="form-group">
                                                    <Field className="form-control" name="pry_home" autoComplete="off" component={RenderField} type="text" label="Casa" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-12 col-md-12 col-lg-12">
                                            <div className="form-group">
                                                <Field className="form-control" name="pry_address_description" autoComplete="off" component={RenderField} type="text" label="Más información" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12 text-center">
                                    <button type="submit" className="btn btn-warning btn-lg pd-button pd-form" disabled={submitting}>Continuar</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </Section>
        );
    }
}

PryAddressForm.contextTypes = {
    intl: React.PropTypes.object.isRequired
}

const selector = formValueSelector('PryAddressForm')

PryAddressForm = connect(
    state => {
        const state_id = selector(state, 'state_id')
        const zip_code = selector(state, 'form_locality')
        return {
            zip_code,
            state_id
        }
    }
)(PryAddressForm)

PryAddressForm = TopScrolleable(PryAddressForm);

PryAddressForm = reduxForm({
    form: 'PryAddressForm', // a unique name for this form
    validate
})(PryAddressForm);

PryAddressForm = withAuthControl(PryAddressForm);

export default PryAddressForm;



/** WEBPACK FOOTER **
 ** ./src/components/PryAddressForm.js
 **/